/**
 * @generated SignedSource<<109e8694636ff13a877412715e0bf493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobRatesFields_Job$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RateExplanation_Job">;
  readonly " $fragmentType": "JobRatesFields_Job";
};
export type JobRatesFields_Job$key = {
  readonly " $data"?: JobRatesFields_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobRatesFields_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobRatesFields_Job",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RateExplanation_Job"
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "63ef75de52b4d4610974d5d4ad7bdf51";

export default node;
